import { memo } from 'react';
import ChevronRightRoundedIcon from '@mui/icons-material/ChevronRightRounded';
import { MaybeLink } from '@trinity/chat-components/components/presentation/MaybeLink.js';
import { Tooltip } from '@trinity/chat-components/components/presentation/Tooltip.js';
import { cx } from '@trinity/chat-components/utils';
import type { LocationDescriptor } from 'history';
import styles from './style/ViewAll.module.css';

type Props = {
  className?: string;
  onClick?: () => void;
  to?: string | LocationDescriptor;
  title?: string;
};

export const ResponsesViewAll = memo(({ className, onClick, to, title }: Props) => {
  return (
    <div className={cx(styles.chevron, className)}>
      <MaybeLink
        to={to}
        className={styles.viewAll}>
        <Tooltip title={title || 'View responses'}>
          <ChevronRightRoundedIcon
            className={styles.chevronIcon}
            onClick={onClick}
            fontSize="large" />
        </Tooltip>
      </MaybeLink>
    </div>
  );
});

export default ResponsesViewAll;